import { useRef } from 'react'
import { useMutation } from 'react-query'
import { v4 as uuid } from 'uuid'

import { useAppStore } from '@/store/hooks'

const context: Record<string | number, unknown> = {
  sessionId: uuid()
}

type Analytics = {
  set(key: string, value: unknown): void
  track(name: string, data?: typeof context): void
}

export default function useAnalytics() {
  const store = useAppStore()

  const mutation = useMutation({
    mutationFn: async (variables: { name: string; data?: typeof context }) => {
      const accessToken = store.getState().authentication.accessToken
      const currentSpaceId = store.getState().context.spaceId

      // Exit early if we don't have an access token
      if (!accessToken) return

      const response = await fetch('/v1/admin/analytics', {
        method: 'post',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
          'x-workgrid-space': currentSpaceId
        },
        body: JSON.stringify(variables)
      })
      if (!response.ok) throw new Error(`Request failed with status: ${response.status}`)
    }
  })

  const analytics = useRef<Analytics>()
  if (!analytics.current) {
    analytics.current = {
      set(key, value) {
        // console.log('[analytics]', 'set', key, value)
        context[key] = value
      },
      track(name, data) {
        // console.log('[analytics]', 'track', name, data)
        mutation.mutate({ name, data: { ...context, ...data } })
      }
    }
  }

  return analytics.current
}
